import { FC } from 'react';

import { Theme } from '@mui/material';
import { Box, Typography } from '@mui/material';
import { NeutralColors } from 'portfolio3/styles';

import { IRecommendedSpeciality } from '../../model/types';

export const styles = (theme: Theme, ignoreBreakpoints: boolean) => {
  const baseStyles = {
    display: 'flex',
    justifyContent: 'space-between',
    gap: '4px',
    width: 'fit-content',
  };

  if (ignoreBreakpoints) {
    return baseStyles;
  }

  return {
    ...baseStyles,

    [theme.breakpoints.down('commonSm')]: {
      width: '100%',
    },
  };
};

interface ISpecialityProps {
  speciality: IRecommendedSpeciality;
  ignoreBreakpoints?: boolean;
}

const Speciality: FC<ISpecialityProps> = ({ speciality, ignoreBreakpoints = false }) => {
  return (
    <Box className="speciality" sx={(theme) => styles(theme, ignoreBreakpoints)}>
      <Typography variant="Paragraph MD/Regular" color={NeutralColors.light_neutrals_600} paddingTop="2px">
        {speciality.code}
      </Typography>
      <Typography variant="Paragraph LG/Regular">{speciality.name}</Typography>
    </Box>
  );
};

export default Speciality;
